import { render, staticRenderFns } from "./rollback-form-dialog.vue?vue&type=template&id=85c81e0e"
import script from "./rollback-form-dialog.vue?vue&type=script&lang=js"
export * from "./rollback-form-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports